import React from 'react';
import { Carrier, CarrierFilters } from '../../../app/models/Carrier';
import ButtonTableAction from '../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../components/default/DefaultDataTable';
import CarrierFilter from './CarrierFilter';

interface Props {
    carriers: Carrier[];
    edit?: (PlaceId: number) => void;
    destroy?: (PlaceId: number) => void;
    show?: (DailyPlaceId: number) => void;
    loading?: boolean;
    filter: CarrierFilters;
    setFilter: (filter: CarrierFilters) => void;
    totalRows: number;
}

const CarrierDataTable = ({
    carriers,
    edit,
    destroy,
    loading = false,
    show,
    filter,
    setFilter,
    totalRows
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row?.id,
            sortable: true,
            sortField: 'id'
        },
        {
            name: 'Rut',
            selector: (row: any) => row?.rut,
            sortable: true,
            sortField: 'rut'
        },
        {
            name: 'Nombre',
            selector: (row: any) => row?.name,
            sortable: true,
            sortField: 'name'
        },
        {
            name: 'Email',
            selector: (row: any) => row?.email,
            sortable: true,
            sortField: 'email'
        },
        {
            name: 'Teléfono',
            selector: (row: any) => row?.phone,
            sortable: true,
            sortField: 'phone',
            cell: (row: any, index: any, column: any) => {
                return `${row.phone_code} ${row.phone}`;
            }
        },
        {
            name: 'Dirección',
            selector: (row: any) => row?.address,
            sortable: true,
            sortField: 'address'
        },
        {
            name: 'Acciones',
            selector: (row: any) => row?.id,
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <div className="nowrap-cell nowrap-cell-no-min">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <div>
            <div className="col-12 mt-md-0 mt-3">
                <div className="row">
                    <div className="col">
                        <CarrierFilter filter={filter} setFilter={setFilter} />
                    </div>
                </div>
            </div>
            <div className="col-12 mt-4">
                <DefaultDataTable
                    columns={columns}
                    data={carriers}
                    progressPending={loading}
                    paginationTotalRows={totalRows}
                    filter={filter}
                    setFilter={setFilter}
                />
            </div>
        </div>
    );
};

export default CarrierDataTable;
